import call from "./call";
import {
  MicrosoftStatus,
  MicrosoftConnectResponse,
  SharepointLink,
  SharepointLinksResponse,
} from "../Models/sharepointLink";

export const getMicrosoftStatus = async (): Promise<MicrosoftStatus> => {
  const { data } = await call.get<MicrosoftStatus>("/v1/microsoft/status/", {
    snack: {
      error: "microsoft.statusError",
    },
  });
  return data;
};

export const getMicrosoftConnectUrl =
  async (): Promise<MicrosoftConnectResponse> => {
    const { data } = await call.get<MicrosoftConnectResponse>(
      "/v1/microsoft/connect/",
      {
        snack: {
          error: "microsoft.connectError",
        },
      },
    );
    return data;
  };

export const disconnectMicrosoft = async () => {
  const response = await call.delete("/v1/microsoft/disconnect/", {
    snack: {
      success: "microsoft.disconnectSuccess",
      423: "microsoft.disconnectSyncInProgress",
      error: "microsoft.disconnectError",
    },
  });
  return response;
};

export const linkSharepointFolder = async (
  companyId: string,
  folderUrl: string,
): Promise<SharepointLink> => {
  const { data } = await call.post<SharepointLink>(
    "/v1/sharepoint/link/",
    {
      company_id: Number(companyId),
      folder_url: folderUrl,
    },
    {
      snack: {
        success: "sharepoint.linkSuccess",
        400: "sharepoint.linkNotAFolder",
        403: "sharepoint.linkNoAccess",
        404: "sharepoint.linkNoAccess",
        409: "sharepoint.linkConflict",
        error: "sharepoint.linkError",
      },
    },
  );
  return data;
};

export const getSharepointLinks = async (
  companyId: string,
): Promise<SharepointLinksResponse> => {
  const { data } = await call.get<SharepointLinksResponse>(
    `/v1/sharepoint/company/${companyId}/`,
    {
      snack: {
        error: "sharepoint.fetchError",
      },
    },
  );
  return data;
};

export const syncSharepointLink = async (linkId: number) => {
  const response = await call.post(
    `/v1/sharepoint/${linkId}/sync/`,
    {},
    {
      snack: {
        success: "sharepoint.syncStarted",
        409: "sharepoint.syncAccountRevoked",
        423: "sharepoint.syncBusy",
        error: "sharepoint.syncError",
      },
    },
  );
  return response;
};

export const stopSharepointLink = async (linkId: number) => {
  const response = await call.post(
    `/v1/sharepoint/${linkId}/stop/`,
    {},
    {
      snack: {
        success: "sharepoint.stopSuccess",
        error: "sharepoint.stopError",
      },
    },
  );
  return response;
};

export const unlinkSharepointFolder = async (linkId: number) => {
  const response = await call.delete(`/v1/sharepoint/${linkId}/`, {
    snack: {
      success: "sharepoint.unlinkSuccess",
      423: "sharepoint.unlinkBusy",
      error: "sharepoint.unlinkError",
    },
  });
  return response;
};
